import React from 'react';

import { Grid, Section } from '@gogame/components';
import { SidePageV2, FormField, withForm } from '@gogame/form';

import { renderDescriptionList } from '../components/Results';
import { LAST_ACTIVITY, PREVIOUS_ACTIVITY } from './constants';
import { editActivityValidationSchema } from './schema';

const LastActivityForm = withForm({
  validationSchema: editActivityValidationSchema,
})(({ open, onClose, onExited, record }) => {
  return (
    <SidePageV2 onClose={onClose} onExited={onExited} open={open} size={'sm'}>
      <SidePageV2.Title title={'Edit Last Session Date'} />
      <SidePageV2.Content>
        <Section title={'Details'}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {renderDescriptionList(record)}
            </Grid>
            <Grid item container spacing={3}>
              <Grid item xs={9}>
                <FormField.DatePicker
                  name={LAST_ACTIVITY}
                  label={'Last Activity Date'}
                  padding={0}
                  required={true}
                />
              </Grid>
              <Grid item xs={9}>
                <FormField.DatePicker
                  name={PREVIOUS_ACTIVITY}
                  label={'Previous Activity Date'}
                  padding={0}
                />
              </Grid>
            </Grid>
          </Grid>
        </Section>
      </SidePageV2.Content>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});

export default LastActivityForm;
